import XarmService from '../services/xarm.service'
import { handleCookieError } from '../utils/utils.js'
import router from '@/router'

export const xarmModule = {
  namespaced: true,

  actions: {
    async createRoleAdministrateur ({ commit }, login) {
      return XarmService.createRoleAdministrateur(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async createRoleAdministrateurBo ({ commit }, login) {
      return XarmService.createRoleAdministrateurBo(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async createRoleGestionnaire ({ commit }, login) {
      return XarmService.createRoleGestionnaire(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async createRolePorteur ({ commit }, login) {
      return XarmService.createRolePorteur(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async createRoleDemoGestionnaire ({ commit }, login) {
      return XarmService.createRoleDemoGestionnaire(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async createRoleDemoPorteur ({ commit }, login) {
      return XarmService.createRoleDemoPorteur(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async createXarmRoleLogsAdmin ({ commit }, login) {
      return XarmService.createXarmRoleLogsAdmin(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async addPermAddtPorteurData ({ commit }, login) {
      return XarmService.addPermAddtPorteurData(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async addPermissDDDSecure ({ commit }, login) {
      return XarmService.addPermissDDDSecure(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async addPermissEmailMaj ({ commit }, login) {
      return XarmService.addPermissEmailMaj(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async addPermAddtPorteurDataAdmin ({ commit }, login) {
      return XarmService.addPermAddtPorteurDataAdmin(login).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getPermissionsForRole ({ commit }, roleName) {
      return XarmService.getPermissionsForRole(roleName).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async addOrRemovePermissions ({ commit }, permissionAndRoleName) {
      return XarmService.addOrRemovePermissions(permissionAndRoleName).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    }
  }
}
